import messengerSvg from '!!raw-loader!../defaultSvg/messenger.svg';
import whatsAppBusinessSvg from '!!raw-loader!../defaultSvg/whatsAppBusiness.svg';
import whatsAppPersonalSvg from '!!raw-loader!../defaultSvg/whatsAppPersonal.svg';
import phoneSvg from '!!raw-loader!../defaultSvg/phone.svg';
import emailSvg from '!!raw-loader!../defaultSvg/email.svg';
import instagramSvg from '!!raw-loader!../defaultSvg/instagram.svg';
import lineSvg from '!!raw-loader!../defaultSvg/line.svg';
import linkedinSvg from '!!raw-loader!../defaultSvg/linkedin.svg';
import xSvg from '!!raw-loader!../defaultSvg/x.svg';

import weChatSvg from '!!raw-loader!../defaultSvg/weChat.svg';

let channelsList = [
	{
		name: 'Messenger',
		type: 1,
		iconLink: '',
		linkPath: '',
		textInfo: '',
		defaultSvg: messengerSvg,
	},
	{
		name: 'WhatsApp Business',
		type: 2,
		iconLink: '',
		linkPath: '',
		textInfo: '',
		defaultSvg: whatsAppBusinessSvg,
	},
	{
		name: 'WhatsApp个人',
		type: 3,
		label: 'WhatsApp',
		iconLink: '',
		linkPath: '',
		textInfo: '',
		defaultSvg: whatsAppPersonalSvg,
	},
	{
		name: '电话',
		type: 4,
		label: '电话号码',
		linkPath: '',
		iconLink: '',
		textInfo: '',
		defaultSvg: phoneSvg,
	},
	{
		name: '邮箱',
		type: 5,
		linkPath: '',
		iconLink: '',
		textInfo: '',
		defaultSvg: emailSvg,
	},
	{
		name: 'Instagram',
		type: 6,
		label: 'Instagram链接',
		linkPath: '',
		iconLink: '',
		textInfo: '',
		defaultSvg: instagramSvg,
	},
	{
		name: 'Line',
		type: 7,
		label: 'Line链接',
		linkPath: '',
		iconLink: '',
		textInfo: '',
		defaultSvg: lineSvg,
	},
	{
		name: 'LinkedIn',
		type: 8,
		label: 'Linkedin链接',
		linkPath: '',
		iconLink: '',
		textInfo: '',
		defaultSvg: linkedinSvg,
	},
	{
		name: 'X',
		type: 9,
		label: 'X链接',
		linkPath: '',
		iconLink: '',
		textInfo: '',
		defaultSvg: xSvg,
	},
	{
		name: 'WeChat',
		type: 10,
		linkPath: '',
		iconLink: '',
		textInfo: '',
		defaultSvg: weChatSvg,
	},
];

export default channelsList;
